import { useCallback, useContext } from 'react';
import { BlockKitContext } from '../contexts/context';
export var usePermissions = function usePermissions() {
  var _a, _b, _c;
  var context = useContext(BlockKitContext);
  var permissions = (_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.appContext) === null || _a === void 0 ? void 0 : _a.authInfo) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.permissions;
  var checkPermissions = useCallback(function (testPermissions) {
    var regExp = new RegExp(testPermissions.join('|'));
    return Boolean(permissions === null || permissions === void 0 ? void 0 : permissions.some(function (permission) {
      return regExp.test(permission);
    }));
  }, [permissions]);
  return {
    permissions: permissions,
    checkPermissions: checkPermissions
  };
};